// @ts-strict-ignore
/* eslint-disable camelcase */
import { Controller } from '@hotwired/stimulus'
import { debounce } from '../../utils/component-events'
import { trackComponent } from '../tracking'

export default class extends Controller<HTMLFormElement> {
  static targets = [
    'carouselButtons',
    'carouselCard',
    'carouselContainer',
    'leftArrowIcon',
    'rightArrowIcon',
  ]

  declare readonly carouselButtonsTargets: HTMLElement[]
  declare readonly carouselCardTargets: HTMLElement[]
  declare readonly carouselCardTarget: HTMLElement
  declare readonly carouselContainerTarget: HTMLElement
  declare readonly leftArrowIconTarget: HTMLElement
  declare readonly rightArrowIconTarget: HTMLElement
  handleScroll: (...args: any) => void
  scrollCounter: number
  cardLength: any

  constructor(props: any) {
    super(props)
    this.handleScroll = debounce(this.updateButtons, 50).bind(this)
    this.scrollCounter = 0
    this.cardLength = this.carouselCardTargets.length
  }

  trackScroll = (newIndex: number) => {
    const activeCard = this.carouselCardTargets[newIndex]
    const trackingProps =
      activeCard?.getAttribute('data-scroll-tracking') &&
      JSON.parse(activeCard.getAttribute('data-scroll-tracking')!)
    const componentData = {
      component_category: trackingProps?.component_category,
      component_id: trackingProps?.component_id,
      component_name: trackingProps?.component_name,
      contentful_name: trackingProps?.contentful_name,
      contentful_variant: trackingProps?.contentful_variant,
    }
    trackComponent('Dynamic Component Event', 'component_scrolled', componentData, {
      ...trackingProps?.additionalProps,
      carouselPosition: newIndex + 1,
    })
  }

  updateButtons = () => {
    const cards = this.carouselCardTargets

    // get index of last element where left is less than half the viewport
    const newIndex = Array.from(cards)
      .map(
        (ele) =>
          ele.getBoundingClientRect().left > 0 &&
          ele.getBoundingClientRect().left < window.innerWidth / 2,
      )
      .lastIndexOf(true)

    Array.from(this.carouselButtonsTargets).forEach((button, i) => {
      if (i === newIndex) {
        button.setAttribute('data-vanilla-carousel-nav-button-active', 'true')
        this.trackScroll(newIndex)
      } else {
        button.setAttribute('data-vanilla-carousel-nav-button-active', 'false')
      }
    })
  }

  scrollCards(event: any, distance: number) {
    const arrLeft = this.leftArrowIconTarget.getElementsByTagName('use')
    const arrRight = this.rightArrowIconTarget.getElementsByTagName('use')

    this.scrollCounter += distance

    const brand = window.__BRAND__

    if (this.scrollCounter === 0) {
      arrLeft[0].setAttribute(
        'href',
        `/fs-core-assets/icons/${brand}/ButtonLeftDisabled.svg?v=5#ButtonLeftDisabled`,
      )
      arrRight[0].setAttribute(
        'href',
        `/fs-core-assets/icons/${brand}/arrow-right.svg?v=5#arrow-right`,
      )
    } else if (this.scrollCounter === this.cardLength - 3) {
      arrRight[0].setAttribute(
        'href',
        `/fs-core-assets/icons/${brand}/ButtonRightDisabled.svg?v=5#ButtonRightDisabled`,
      )
      arrLeft[0].setAttribute(
        'href',
        `/fs-core-assets/icons/${brand}/arrow-left.svg?v=5#arrow-left`,
      )
    } else {
      arrRight[0].setAttribute(
        'href',
        `/fs-core-assets/icons/${brand}/arrow-right.svg?v=5#arrow-right`,
      )
      arrLeft[0].setAttribute(
        'href',
        `/fs-core-assets/icons/${brand}/arrow-left.svg?v=5#arrow-left`,
      )
    }

    this.carouselContainerTarget.scrollBy({
      left: (this.carouselCardTargets[0].offsetWidth + 16) * distance,
      behavior: 'smooth',
    })
    event.preventDefault()
  }

  leftArrowClick() {
    const cardWidth = this.carouselCardTarget.clientWidth
    this.carouselContainerTarget.scrollBy(-1 * (cardWidth / 2), 0)
  }

  rightArrowClick() {
    const cardWidth = this.carouselCardTarget.clientWidth
    this.carouselContainerTarget.scrollBy(cardWidth / 2, 0)
  }

  leftArrowIconClick(event) {
    if (this.scrollCounter !== 0) {
      this.scrollCards(event, -1)
    }
  }

  rightArrowIconClick(event) {
    if (this.scrollCounter !== this.cardLength - 3) {
      this.scrollCards(event, 1)
    }
  }

  connect() {
    Array.from(this.carouselButtonsTargets).forEach((carouselButton: any, i: number) => {
      carouselButton.addEventListener('click', () => {
        const cardWidth = this.carouselCardTargets[i].clientWidth
        const activeIndex = Array.from(this.carouselButtonsTargets).findIndex((button) => {
          const dataset = button.dataset
          return dataset.vanillaCarouselNavButtonActive === 'true'
        })
        this.carouselContainerTarget.scrollBy((i - activeIndex) * cardWidth, 0)
      })
    })
  }
}
